
<!-- Caixa de chat -->
<div class="ajuda-chat" *ngIf="aberto">
  <div class="ajuda-header">
    <div>Secretária Virtual</div>
    <button class="fechar" (click)="toggle()">×</button>
  </div>

  <div class="ajuda-body" #scrollArea>
    <div *ngFor="let m of mensagens" class="linha" [ngClass]="{ 'dir': isDireita(m), 'esq': !isDireita(m) }">
      <div class="bolha">
        <div class="texto">{{ m.texto }}</div>
        <div class="opcoes" *ngIf="m.opcoes?.length && !isDireita(m)">
          <button class="opcao" *ngFor="let op of m.opcoes" (click)="selecionarOpcao(m, op)">{{ op }}</button>
        </div>
        <div class="hora">{{ m.data | date:'shortTime' }}</div>
      </div>
    </div>

    <!-- Indicador de digitação da IA -->
    <div *ngIf="aguardandoResposta" class="linha esq">
      <div class="bolha">
        <div class="texto">...</div>
      </div>
    </div>
  </div>

  <div class="ajuda-footer">
    <input #inputMensagem type="text" [(ngModel)]="texto" (keyup.enter)="enviar()" placeholder="Digite sua mensagem..." autocomplete="off" />
    <button class="enviar" (click)="enviar()" [disabled]="!(texto || '').trim()">Enviar</button>
  </div>
</div>
